import { render, staticRenderFns } from "./RessifnetDateInput.vue?vue&type=template&id=37a4b657&"
import script from "./RessifnetDateInput.vue?vue&type=script&lang=ts&"
export * from "./RessifnetDateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports